import React, { memo, useRef } from 'react';
import { capitalize, handleWheelScroll } from 'utility/functions';

import { ItemWithTranslation } from 'types/swagger';
import classNames from 'classnames';
import styles from './SportManifestazioniTabs.module.scss';
import { useTranslation } from 'hooks/useLingUI';

export type SportManifestazioniTabType = ItemWithTranslation<{ textTab?: string }> & {
  idTab: string;
  counter?: number;
};

export type SportManifestazioniTabsProps = {
  listTab: Array<SportManifestazioniTabType>;
  children: React.ReactNode;
  className?: string;
  handleClick: (tab: string) => void;
  currentTab: string;
  classNameTabList?: string;
  removeTabs?: boolean;
  gtagAction?: (_: string) => void;
};

export const SportManifestazioniTabs = memo(function SportManifestazioniTabs({
  listTab,
  children,
  className,
  currentTab,
  removeTabs,
  classNameTabList,
  handleClick,
  gtagAction,
}: SportManifestazioniTabsProps) {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLUListElement>(null);

  return (
    <div className={classNames(styles.container, className ?? '')}>
      {/* Tab List */}
      {!removeTabs && (
        <ul
          ref={containerRef}
          className={classNames(styles.tabList, classNameTabList)}
          onWheel={(e) => handleWheelScroll(containerRef, e)}
        >
          {listTab?.map((item, index) => {
            const { idTab, counter, textTab, textTabTrKey } = item ?? {};
            return (
              <li key={idTab + '_' + index} className={styles.itemTab}>
                <button
                  type="button"
                  className={`${styles.tabTrigger} ${+currentTab - 1 === index && styles.tabTriggerActive}`}
                  suppressHydrationWarning={true}
                  onClick={() => {
                    // if (textTab && typeof gtagAction === 'function') {
                    //   gtagAction(textTab);
                    // }
                    handleClick(`${index + 1}`);
                  }}
                >
                  {capitalize(t(textTabTrKey, textTab))}
                  {item.hasOwnProperty('counter') && ` (${counter})`}
                </button>
              </li>
            );
          })}
        </ul>
      )}
      {/* Tab Content */}
      <div className={styles.tabContent}>{children}</div>
    </div>
  );
});